import { Checkbox, Input, Modal, Select, Typography } from "antd";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { top_up } from "../../actions/cards/cards";
import Close from "../../assets/icons/close.png";
import { items } from "../Auth/InfoNPolicies";
import TermsandCondition from "./TermsandCondition";
import "antd/dist/antd.css";

const { Title } = Typography;

const TopUpModel = ({
  topUpModel,
  handleCancel,
  setTopUpModel,
  card_data,
  walletData,
}) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [terms, setTerms] = useState(false);
  const formik = useFormik({
    initialValues: {
      amount: "",
      wallet_identifier: "",
    },
    onSubmit: (vals) => {
      dispatch(
        top_up({
          amount: vals.amount,
          card_id: card_data?.id,
          wallet_identifier: vals.wallet_identifier,
        })
      );
    },
    validationSchema: Yup.object().shape({
      wallet_identifier: Yup.string().required("Wallet is required"),
      amount: Yup.string()
        .required("Amount is required")
        .test("amount_reg", "Amount Should be greater than 0", (val) => {
          if (Number(val) > 0) {
            return true;
          } else {
            return false;
          }
        }),
    }),
  });

  useEffect(() => {
    if (!topUpModel) {
      formik.resetForm();
      setIsChecked(false);
    }
  }, [topUpModel]);

  return (
    <>
      <Modal
        title={<Title level={4}>Top Up &nbsp;</Title>}
        visible={topUpModel}
        onCancel={() => {
          handleCancel();
        }}
        footer={[]}
        width={450}
        closable={false}
      >
        <span
          className="cursor"
          onClick={() => {
            setTopUpModel(false);
          }}
          style={{ position: "absolute", right: 10, top: 10 }}
        >
          <img src={Close} width={20} alt={"close"} />
        </span>
        <form className="topup" onSubmit={formik.handleSubmit}>
          <div className="ant-col ant-form-item-label">
            <label className="ant-form-item-required" title="Field A">
              Topup Amount
            </label>
          </div>
          <Input
            placeholder="Amount"
            value={formik.values.amount}
            maxLength={5}
            onChange={(e) => {
              if (e.target.value && Number.isNaN(Number(e.target.value))) {
                return;
              }
              if (/^[0-9]*$/.test(e.target.value) === true) {
                formik.setFieldValue("amount", e.target.value);
              }
            }}
          />
          <div className="errorMsg">
            {formik.touched.amount && formik.errors.amount}
          </div>
          <div className="ant-col ant-form-item-label">
            <label className="ant-form-item-required" title="Field A">
              Wallet
            </label>
          </div>
          <Select
            value={formik.values.wallet_identifier}
            options={walletData
              ?.filter(({ wallet_name }) =>
                ["personal", "transit"].includes(wallet_name?.toLowerCase())
              )
              .map(({ wallet_name }) => ({
                label: wallet_name + " WALLET",
                value: wallet_name,
              }))}
            className="w100"
            onChange={(val) => {
              formik.setFieldValue("wallet_identifier", val);
            }}
            placeholder="Select Wallet"
          />
          <div className="errorMsg">
            {formik.touched.wallet_identifier &&
              formik.errors.wallet_identifier}
          </div>
          <p className="mb1 mt1 message">
            You are leaving the Paycraft application and being redirected to the
            Payment gateway webpage after clicking on Continue.
            <br />
            <br />
            If you don't want to continue, Press Cancel.
          </p>
          <p className="note mt1">
            Note:- Browser popup permission should be enabled for the
            redirection.
          </p>
          {/* <p>
            <Checkbox
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
              }}
            />{" "}
            I have read and agree to{" "}
            <b className="cursor" onClick={() => setIsModalVisible(true)}>
              Terms & Conditions
            </b>
          </p> */}
          <div>
            {isModalVisible && (
              <Modal
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={[]}
                width={750}
                className="police_modal"
              >
                <TermsandCondition />
              </Modal>
            )}
          </div>
          <div className="top-filter mt1">
            <div className="flt-btns">
              <button
                type="button"
                onClick={() => {
                  setTopUpModel(false);
                }}
              >
                <span>Cancel</span>
              </button>
              <button className="active">
                <span>Continue</span>
              </button>
            </div>
          </div>
        </form>
      </Modal>
      <Modal
        title={<Title level={4}>Terms & Conditions</Title>}
        visible={terms}
        onCancel={() => {
          setTerms(false);
        }}
        footer={[]}
        width={650}
        closable={false}
      >
        <div className="policies_css">{items[3].children}</div>
      </Modal>
    </>
  );
};

export default TopUpModel;
